import React from 'react';
import Row from '../../../shared/components/Row';
import { ContractorFileCreateRequest } from './webservices/ContractorFileCreateRequest';
import { ContractorFileCreateTask } from './webservices/ContractorFileCreateTask';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import Alert from 'react-s-alert';
import * as navigationActions from '../../../shared/utils/NavigationActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ContractorFileFormCard from '../ContractorFileForm';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import Card from '../../../shared/components/Card';

class DocumentaryLibraryCreate extends React.Component {

    render() {
        return (
            <Row>
                <Card>
                    <CardHeader title={I18nUtils.tr('TR_NUEVO_DOCUMENTO').toUpperCase()}/>
                    <ContractorFileFormCard
                        initialValues={{}}
                        onSubmit={this.createContractorFile}
                    />
                </Card>
            </Row>
        );
    }

    createContractorFile = (values) => {
        const request = new ContractorFileCreateRequest({
            name: values.name,
            file: values.file[0].file,
        });

        new ContractorFileCreateTask(request)
            .onSuccess(() => {
                Alert.success(I18nUtils.tr('TR_DOCUMENTO_CREADO_CORRECTAMENTE'));
                window.location.reload()

            })
            .onFail(error => Alert.error(error))
            .execute();
    };
}

const mapDispatchToProps = dispatch => ( { navigation: bindActionCreators(navigationActions, dispatch) } );

export const DocumentaryLibraryCreateContent = connect(null, mapDispatchToProps)(DocumentaryLibraryCreate);

DocumentaryLibraryCreateContent.propTypes = {};

DocumentaryLibraryCreateContent.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documentary-library/form/create/DocumentaryLibraryCreateContent.jsx